module.exports = __webpack_public_path__ + "static/media/5-audio.5a6e52d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/5-audio.wav
// module id = 2NP6
// module chunks = 1